import BaseCatalogViewModel from 'Common/baseCatalogModel';

class ViewModel extends BaseCatalogViewModel {
    constructor() {
        super();
    }

    searchParams() {
        return {
            brandId: this.model.Id(),
            pageSize: 96
        };
    }

    pageId() {
        return this.model.Id();
    }
}

var vm = new ViewModel();
(async () => {
    await vm.init();
})().catch(err => console.error(err));

window.vm = vm;